import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bf266f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PaneListRemediationTasks CustomScrollbar" }
const _hoisted_2 = { class: "PaneIntro" }
const _hoisted_3 = {
  key: 0,
  class: "List"
}
const _hoisted_4 = { class: "ListLabels PaneLine Disabled" }
const _hoisted_5 = { class: "Label" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_7 = { class: "ListContent" }
const _hoisted_8 = { class: "List" }
const _hoisted_9 = { class: "ListLabels" }
const _hoisted_10 = { class: "Label" }
const _hoisted_11 = { class: "PaneEmptyText" }
const _hoisted_12 = {
  key: 2,
  class: "List"
}
const _hoisted_13 = { class: "ListLabels PaneLine Disabled" }
const _hoisted_14 = { class: "Label" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_16 = { class: "ListContent" }
const _hoisted_17 = { class: "List" }
const _hoisted_18 = { class: "ListLabels" }
const _hoisted_19 = { class: "Label" }
const _hoisted_20 = { class: "PaneEmptyText" }
const _hoisted_21 = {
  key: 4,
  class: "List"
}
const _hoisted_22 = { class: "ListLabels PaneLine Disabled" }
const _hoisted_23 = { class: "Label" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "LabelGroup" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_26 = { class: "ListContent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaneTitle = _resolveComponent("PaneTitle")!
  const _component_PageVideoGuide = _resolveComponent("PageVideoGuide")!
  const _component_PaneLineRemediation = _resolveComponent("PaneLineRemediation")!
  const _component_PaneLink = _resolveComponent("PaneLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PaneTitle, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.mixWB('REMEDIATION_TASKS')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('REMEDIATION_PAGE_INTRO_TEXT_1')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('REMEDIATION_PAGE_DISCLAIMER_TEXT_1')), 1),
      _createVNode(_component_PageVideoGuide, { guide: "remediation" })
    ]),
    (_ctx.withCleaning.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.mixWB('WITH_CLEANING')) + " (" + _toDisplayString(_ctx.withCleaning.length) + ")", 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.withCleaning, (oType) => {
              return (_openBlock(), _createBlock(_component_PaneLink, {
                key: oType.hashID,
                class: "PaneLine",
                "pane-id": oType.hashID
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PaneLineRemediation, { onlineType: oType }, null, 8, ["onlineType"])
                ]),
                _: 2
              }, 1032, ["pane-id"]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.mixWB('WITH_CLEANING')), 1)
            ])
          ]),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.mixWB('NO_TASKS_FOUND')), 1)
        ], 64)),
    (_ctx.withoutCleaning.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.mixWB('WITHOUT_CLEANING')) + " (" + _toDisplayString(_ctx.withoutCleaning.length) + ")", 1),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.withoutCleaning, (oType) => {
              return (_openBlock(), _createBlock(_component_PaneLink, {
                key: oType.hashID,
                class: "PaneLine",
                "pane-id": oType.hashID
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PaneLineRemediation, { onlineType: oType }, null, 8, ["onlineType"])
                ]),
                _: 2
              }, 1032, ["pane-id"]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.mixWB('WITHOUT_CLEANING')), 1)
            ])
          ]),
          _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.mixWB('NO_TASKS_FOUND')), 1)
        ], 64)),
    (_ctx.potential.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.mixWB('POTENTIAL_REMEDIATION_TASKS')) + " (" + _toDisplayString(_ctx.potential.length) + ")", 1),
            _hoisted_24,
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.potential, (oType) => {
              return (_openBlock(), _createBlock(_component_PaneLink, {
                key: oType.hashID,
                class: "PaneLine",
                "pane-id": oType.hashID
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PaneLineRemediation, { onlineType: oType }, null, 8, ["onlineType"])
                ]),
                _: 2
              }, 1032, ["pane-id"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}